import { useState } from "react";

export default function FollowBox() {
  const [keyword, setKeyword] = useState("");
  const [message, setMessage] = useState("");

  const handleFollow = () => {
    const value = keyword.trim();
    if (!value) {
      setMessage("先填写你关注的关键词，再点跟进");
      return;
    }
    setMessage(`已记录「${value}」，有新料时会优先提醒（演示效果，未真正保存）`);
  };

  return (
    <section id="follow" className="bg-background-950 py-16 md:py-24">
      <div className="mx-auto max-w-5xl px-4 md:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.1fr_0.9fr] lg:items-center lg:gap-16">
          <div>
            <p className="flex items-center gap-2 text-xs font-semibold tracking-[0.25em] text-accent-400 md:text-sm">
              <i className="ri-notification-3-line"></i>
              FOLLOW UP
            </p>
            <h2 className="mt-3 font-heading text-3xl font-black text-background-50 md:text-5xl">
              跟进爆料，不错过后料
            </h2>
            <p className="mt-4 max-w-xl text-sm leading-loose text-background-100/75 md:text-base">
              填一个你关注的关键词，我们会把它记进跟进清单，有新的爆料直达时就优先拎出来，省得你在快讯流里反复翻找。
            </p>
          </div>

          <div className="rounded-lg border border-background-50/15 bg-background-50/5 p-5 md:p-7">
            <label htmlFor="follow-keyword" className="text-xs font-medium tracking-wide text-background-100/70">
              关注的关键词 / 事件
            </label>
            <div className="mt-3 flex flex-col gap-3 sm:flex-row">
              <input
                id="follow-keyword"
                name="follow_keyword"
                type="text"
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="例如：新剧路透"
                autoComplete="off"
                maxLength={40}
                className="w-full flex-1 rounded-md border border-background-50/20 bg-background-950/60 px-4 py-3 text-sm text-background-50 placeholder:text-background-100/40 focus:border-accent-400 focus:outline-none"
              />
              <button
                type="button"
                onClick={handleFollow}
                className="whitespace-nowrap rounded-md bg-accent-500 px-7 py-3 text-sm font-semibold text-background-950 transition-colors hover:bg-accent-400"
              >
                加入跟进
              </button>
            </div>
            {message ? (
              <p className="mt-4 flex items-start gap-2 text-xs leading-relaxed text-accent-300">
                <i className="ri-checkbox-circle-line mt-0.5"></i>
                {message}
              </p>
            ) : (
              <p className="mt-4 text-xs leading-relaxed text-background-100/50">
                本页面为静态展示，提交仅作演示，不会保存或发送任何数据。
              </p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}